import { Outlet } from "react-router-dom";
import styles from "./AppLayout.module.css";
import { usePermissions } from "context/PermissionContext";
import Header from "components/ui/Header/Header";
import Row from "components/ui/Row/Row";
import Sidebar from "components/ui/Sidebar/Sidebar";
import Main from "components/ui/Main/Main";
import Breadcrumbs from "components/ui/Breadcrumbs/Breadcrumbs";

export default function AppLayout() {
  const { clientPermissions, permissions, subClientPermissions } =
    usePermissions();
  return (
    <div className={styles["appLayout"]}>
      <Header />
      <Row>
        <Sidebar
          clientPermissions={clientPermissions || []}
          permissions={permissions || []}
          subClientPermissions={subClientPermissions || []}
        />
        <Main>
          {/* <Breadcrumbs /> */}
          <Outlet />
        </Main>
      </Row>
    </div>
  );
}
